
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/airship",
      function () {
        return require("private-next-pages/destinations/airship.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/airship"])
      });
    }
  